module.exports = __webpack_public_path__ + "img/add.cce95cc2.svg";